import { API_ENDPOINTS } from '../config/apis';
import { apiRequest } from './client';

export type LoginRequest = {
  account: string;
  password: string;
};

export type LoginResponse = {
  trxId: string;
};

export type VerifyEmailCodeRequest = {
  trxId: string;
  code: string;
};

export type VerifyEmailCodeResponse = {
  accessToken: string;
};

export type ResendEmailCodeRequest = {
  trxId: string;
};

export type PasswordResetEmailRequest = {
  email: string;
};

export type PasswordResetTokenVerifyResponse = {
  isValid: boolean;
  account?: string;
  email?: string;
  inviteType?: 'INITIAL_SET' | 'RESET';
};

export type PasswordResetConfirmRequest = {
  password: string;
  urlToken: string;
};

export type PasswordChangeRequest = {
  currentPassword: string;
  newPassword: string;
};

export function requestLogin(request: LoginRequest) {
  return apiRequest<LoginResponse, LoginRequest>(API_ENDPOINTS.authLogin, {
    body: request,
    useAuth: false,
  });
}

export function requestVerifyEmailCode(request: VerifyEmailCodeRequest) {
  return apiRequest<VerifyEmailCodeResponse, VerifyEmailCodeRequest>(
    API_ENDPOINTS.authEmailCodeVerify,
    {
      body: request,
      useAuth: false,
    }
  );
}

export function requestResendEmailCode(request: ResendEmailCodeRequest) {
  return apiRequest<Record<string, never>, ResendEmailCodeRequest>(
    API_ENDPOINTS.authEmailCodeResend,
    {
      body: request,
      useAuth: false,
    }
  );
}

export function requestPasswordResetEmail(request: PasswordResetEmailRequest) {
  return apiRequest<Record<string, never>, PasswordResetEmailRequest>(
    API_ENDPOINTS.authPasswordResetByEmail,
    {
      body: request,
      useAuth: false,
    }
  );
}

export function requestPasswordResetTokenVerify(urlToken: string) {
  return apiRequest<PasswordResetTokenVerifyResponse>(
    API_ENDPOINTS.authPasswordResetTokenVerify,
    {
      query: { urlToken },
      useAuth: false,
    }
  );
}

export function requestPasswordResetConfirm(request: PasswordResetConfirmRequest) {
  return apiRequest<Record<string, never>, PasswordResetConfirmRequest>(
    API_ENDPOINTS.authPasswordResetConfirm,
    {
      body: request,
      useAuth: false,
    }
  );
}

export function requestPasswordChange(request: PasswordChangeRequest) {
  return apiRequest<Record<string, never>, PasswordChangeRequest>(API_ENDPOINTS.authPasswordChange, {
    body: request,
  });
}

export function requestLogout() {
  return apiRequest<Record<string, never>>(API_ENDPOINTS.authLogout);
}
